export default __webpack_public_path__ + "images/models/eebd1f79c1e3690c64584dca13ad04f0.glb";